import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { IconButton, Avatar } from "@material-ui/core";
import { connect } from "react-redux";

import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import MeetingRoomIcon from "@material-ui/icons/MeetingRoom";

import MyBooks from "../../../../../Assets/Logo/MyBooks.svg";
import PaymentHistory from "../../../../../Assets/Logo/PaymentHistory.svg";
import RentedBooks from "../../../../../Assets/Logo/RentedBooks.svg";
import MyMessage from "../../../../../Assets/Logo/MyMessage.svg";
import { logout, authorLogout } from "../../../../../redux/action/action";
import { useStyles } from "./ProfileMenu.css";

class ProfileMenu extends Component {
  state = {
    anchorEl: null,
    image: "",
  };

  UNSAFE_componentWillReceiveProps = () => {
    if (this.props.profileImage) {
      this.setState({
        image: true,
      });
    } else {
      this.setState({
        image: false,
      });
    }
  };

  handleClick = (event) => {
    this.setState({
      anchorEl: event.currentTarget,
    });
  };

  handleClose = () => {
    this.setState({
      anchorEl: null,
    });
  };

  handleLogout = () => {
    this.props.logout();
  };

  handleAuthorLogout = () => {
    this.props.authorLogout();
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        <IconButton onClick={this.handleClick} disableRipple>
          <Avatar style={{ width: 50, height: 50 }}>
            <div style={{ fontSize: 35, color: "black", fontWeight: "bold" }}>
              {this.props.toShow}
            </div>
          </Avatar>
        </IconButton>
        <Menu
          id="simple-menu"
          anchorEl={this.state.anchorEl}
          keepMounted
          open={Boolean(this.state.anchorEl)}
          onClose={this.handleClose}
        >
          <MenuItem className={classes.menuItemContent}>
            <AccountCircleIcon
              style={{
                color: "#0a1f3a",
                width: 30,
                height: 30,
                marginRight: 10,
              }}
            />
            <Link
              to="/profile"
              style={{ textDecoration: "none", color: "black" }}
            >
              Profile
            </Link>
          </MenuItem>
          {this.props.isAuth ? (
            <div>
              <MenuItem className={classes.menuItemContent}>
                <img
                  src={MyBooks}
                  alt="MyBooks"
                  style={{ width: 30, height: 30, marginRight: 10 }}
                />
                <Link
                  to="/mybooks/Customer"
                  style={{ textDecoration: "none", color: "black" }}
                >
                  My Books
                </Link>
              </MenuItem>
              <MenuItem className={classes.menuItemContent}>
                <img
                  src={RentedBooks}
                  alt="RentedBooks"
                  style={{ width: 30, height: 30, marginRight: 10 }}
                />
                <Link
                  to="/myrentedbooks"
                  style={{ textDecoration: "none", color: "black" }}
                >
                  Rented Books
                </Link>
              </MenuItem>
              <MenuItem className={classes.menuItemContent}>
                <img
                  src={PaymentHistory}
                  alt="PaymentHistory"
                  style={{ width: 30, height: 30, marginRight: 10 }}
                />
                <Link
                  to="/payment/history"
                  style={{ textDecoration: "none", color: "black" }}
                >
                  Payment History
                </Link>
              </MenuItem>
              <MenuItem
                className={classes.menuItemContent}
                onClick={this.handleLogout}
              >
                <MeetingRoomIcon
                  style={{
                    color: "#0a1f3a",
                    width: 30,
                    height: 30,
                    marginRight: 10,
                  }}
                />
                <div>Logout</div>
              </MenuItem>
            </div>
          ) : (
            <div>
              <MenuItem className={classes.menuItemContent}>
                <img
                  src={MyBooks}
                  alt="MyBooks"
                  style={{ width: 30, height: 30, marginRight: 10 }}
                />
                <Link
                  to="/mybooks/Author"
                  style={{ textDecoration: "none", color: "black" }}
                >
                  My Books
                </Link>
              </MenuItem>
              <MenuItem className={classes.menuItemContent}>
                <img
                  src={MyMessage}
                  alt="MyMessage"
                  style={{ width: 30, height: 30, marginRight: 10 }}
                />
                <Link
                  to="/mymessage"
                  style={{ textDecoration: "none", color: "black" }}
                >
                  My Messages
                </Link>
              </MenuItem>
              <MenuItem
                className={classes.menuItemContent}
                onClick={this.handleAuthorLogout}
              >
                <MeetingRoomIcon
                  style={{
                    color: "#0a1f3a",
                    width: 30,
                    height: 30,
                    marginRight: 10,
                  }}
                />
                <div>Logout</div>
              </MenuItem>
            </div>
          )}
        </Menu>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuth: state.UserReducer.isAuth,
    isAuthor: state.AuthorReducer.isAuthor,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => {
      dispatch(logout());
    },
    authorLogout: () => {
      dispatch(authorLogout());
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(ProfileMenu));
